import { BaseCamelCasedResource, paramsToString } from "./BaseResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
export class ConnectedLiensOverviewResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.connectedLiens = [];
    }
    pk() {
        return "ConnectedLienEngagement";
    }
    static url(urlParams) {
        return `${this.urlRoot}${paramsToString(urlParams)}`;
    }
}
ConnectedLiensOverviewResource.urlRoot = legacyApiResourceUrl("CustomerEngagement/ConnectedLienEngagement");
//# sourceMappingURL=ConnectedLiensOverviewResource.js.map